(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/bingo/components/bingo-save.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/bingo/components/bingo-save.js');
'use strict';

const {
  useState,
  useEffect
} = React;
const Button = svs.ui.ReactButton;
const TextInput = svs.ui.reactFormInputs.TextInput;
const {
  Form
} = svs.ui.reactForm;
const {
  saveAlias
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  getCustomersPreferences,
  setForceSaveAlias
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  showBaseError,
  aliasAddedDialog,
  aliasRejectedDialog
} = svs.myProfile.react.shared.dialogs;
const {
  validateAlias
} = svs.components.formValidation;

const BingoSave = _ref => {
  let {
    aliasBingo
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const [bingoAlias, setBingoAlias] = useState(aliasBingo);
  useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  const validateBingoAlias = value => {
    const validationResult = {
      errorMessage: '',
      isValid: true
    };
    if (!validateAlias(value)) {
      validationResult.errorMessage = 'Ogiltigt alias. 2-10 tecken, ej enbart siffror. Tillåtna tecken: blanksteg punkt 0-9 a-ö A-Ö é É ü Ü ( ) + _ ? = ! § $ £ @ { }';
      validationResult.isValid = false;
    }
    return validationResult;
  };
  const onSubmitHandler = async (e, formData, isValid) => {
    e.preventDefault();
    if (isValid) {
      var _result$payload;
      const result = await dispatch(saveAlias(bingoAlias));
      if (RTK.isFulfilled(result)) {
        aliasAddedDialog();
        dispatch(setForceSaveAlias(false));
      } else if (((_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.error) === 'taken') {
        var _result$meta, _result$payload2;
        aliasRejectedDialog((_result$meta = result.meta) === null || _result$meta === void 0 ? void 0 : _result$meta.arg, (_result$payload2 = result.payload) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.suggestedAlias);
      } else {
        showBaseError('Ett fel har uppstått', 'Någonting gick fel när Bingo alias skulle sparas. Försök igen eller kontakta kundservice.');
      }
    }
  };
  return React.createElement("div", null, React.createElement(Form, {
    onSubmit: onSubmitHandler
  }, React.createElement("div", {
    className: "f-left relative"
  }, React.createElement(TextInput, {
    "data-validate-alias": "Ogiltigt alias. 2-10 tecken, ej enbart siffror. Till\xE5tna tecken: blanksteg punkt 0-9 a-\xF6 A-\xD6 \xE9 \xC9 \xFC \xDC ( ) - + _ ? = ! \xA7 $ \xA3 @ { }",
    isLessSpace: true,
    label: "Ange alias",
    name: "alias",
    onChange: e => setBingoAlias(e.target.value),
    validateFn: validateBingoAlias,
    value: bingoAlias
  }), React.createElement("p", {
    className: "margin-v-1"
  }, "Ditt alias \xE4r ett smeknamn som visas f\xF6r andra bingospelare p\xE5 spela.svenskaspel.se.", React.createElement("b", null, " Du kan inte byta alias"), ", s\xE5 var noga med att v\xE4lja ett alias som du gillar och vill beh\xE5lla."), React.createElement("p", null, "Svenska Spel kan neka ett valt alias och tilldela dig ett annat, om det alias du har valt kan uppfattas som kr\xE4nkande eller st\xF6tande, inneh\xE5ller f\xF6retagsnamn, varum\xE4rke eller annat personnamn \xE4n ditt eget."), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Spara"))));
};
svs.myProfile.react.pages.myInformation.myInformation.bingo.BingoSave = BingoSave;

 })(window);